import type { Routes } from '@angular/router';

import { canDeactivateAuthCallbackGuard } from './core/auth/can-deactivate-auth-callback.guard';
import { profileCompleteGuard } from './core/auth/profile-complete.guard';
import { CommonSection } from './core/localization/locales/common';
import { ProductErrorsSection } from './core/localization/locales/product';
import { statsdRouteResolve } from './core/routing/statsd.route.resolve';
import { ApplicationShellComponent } from './feature/application-shell/application-shell.component';
import { hasCartItemsGuard } from './pages/cart/cart.guard';

export const routes: Routes = [
	{
		path: 'checkout',
		canLoad: [profileCompleteGuard, hasCartItemsGuard],
		resolve: [statsdRouteResolve],
		loadChildren: () => import('./pages/checkout/checkout.routes').then((m) => m.routes),
	},
	{
		path: '',
		component: ApplicationShellComponent,
		canActivate: [profileCompleteGuard],
		resolve: [statsdRouteResolve],
		children: [
			{
				path: 'auth_callback',
				pathMatch: 'full',
				canDeactivate: [canDeactivateAuthCallbackGuard],
				loadComponent: () => import('./pages/auth-callback/auth-callback.component').then((m) => m.AuthCallbackComponent),
			},
			{
				path: 'order/:orderId',
				loadComponent: () => import('./pages/order/order.component').then((m) => m.OrderComponent),
			},
			{
				path: 'page/:templateId',
				loadComponent: () => import('./pages/page/page.component').then((m) => m.PageComponent),
			},
			{
				path: 'product',
				loadChildren: () => import('./pages/product/product.routes').then((m) => m.routes),
			},
			{
				path: 'cart',
				loadComponent: () => import('./pages/cart/cart.component').then((m) => m.CartComponent),
			},
			{
				path: 'category',
				loadChildren: () => import('./pages/category/category.routes').then((m) => m.routes),
			},
			{
				path: '',
				pathMatch: 'full',
				data: {
					prefetchLocales: [CommonSection, ProductErrorsSection],
				},
				loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
			},
			{
				path: '**',
				loadComponent: () => import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
			},
		],
	},
	{
		path: '**',
		canActivate: [profileCompleteGuard],
		loadComponent: () => import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
	},
];
